module.exports = __webpack_public_path__ + "static/media/1import-1.b691f7e4.xlsx";